import { Injectable, OnInit } from "@angular/core";
import { HttpErrorResponse, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/throw";
import { Constants } from "./constants";
import { Router } from "@angular/router";
import { ApiService } from "./api.service";
import { JwtService } from ".";
import { of } from "rxjs/observable/of";

@Injectable()
export class HandleErrorService {
  numberOfTries = 0;
  constructor(
    private router: Router,
    private jwtService: JwtService,
    private httpClient: HttpClient
  ) {}

  handleHttpResponseError(
    err: HttpErrorResponse,
    url?: string
  ): Observable<any> {
    this.handleUnauthorizedError(err, url);
    if (err instanceof HttpErrorResponse && err.status === 400) {
      return of(err.error);
    }
    if (err instanceof HttpErrorResponse && err.status === 409) {
      return of(err.error);
    }
    if (
      (err instanceof HttpErrorResponse && err.status === 0) ||
      (err instanceof HttpErrorResponse && err.status === 408)
    ) {
      this.numberOfTries++;
      if (this.numberOfTries >= 3) {
        this.numberOfTries = 0;
        // this.httpClient.get('/UIAPI/IsAliveState').subscribe(res => {
        //     console.log(res);
        // });
        // console.log('isAlive handleHttp ' + err);
        // this.router.navigate(['is-alive']);
      }
    }
    // return Observable.throw(Error(Constants.MSG.GENERAL_ERROR));
    // return this.authenticationService.getSession();
  }
  handleUnauthorizedError(err: any, url: string): any {
    if (
      (err instanceof HttpErrorResponse && err.status === 401) ||
      (err.status === 403 && err.error.message === "Access Denied")
    ) {
    }
    return Observable.throw(err);
  }
  handleCognitoResponseError(err: any): Observable<any> {
    switch (err.code) {
      case Constants.COGNITO_EXCETPION.USER_NOT_FOUND:
        return Observable.throw(Error(Constants.MSG.USER_NOT_FOUND));
      case Constants.COGNITO_EXCETPION.NOT_AUTHORIZED:
        return Observable.throw(Error(Constants.MSG.LOGIN_WRONG_CREDENTIALS));
      case Constants.COGNITO_EXCETPION.LIMIT_EXCEEDED:
        return Observable.throw(Error(Constants.MSG.LIMIT_EXCEEDED));
      case Constants.COGNITO_EXCETPION.INVALID_PARAMETER:
        return Observable.throw(Error(Constants.MSG.CANNOT_RESET_PWD));
      case Constants.COGNITO_EXCETPION.CODE_MISMATCH:
        return Observable.throw(Error(Constants.MSG.INVALID_VERIFICATION_CODE));
      case Constants.COGNITO_EXCETPION.USER_NOT_CONFIRMED:
        return Observable.throw(Error(Constants.MSG.USER_NOT_CONFIRMED));
      default:
        return Observable.throw(Error(Constants.MSG.GENERAL_ERROR));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/handle-error.service.ts